import { render, staticRenderFns } from "./UploadDocumentTile.vue?vue&type=template&id=2d0bb4ae&scoped=true"
import script from "./UploadDocumentTile.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0bb4ae",
  null
  
)

export default component.exports